import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_GROWTH_BONUS_IMPRESSION_VALUE_UI = createFcmDetails('growth_bonus_impression_value_ui', {
	owner: 'Growth',
	context: 'Promotion payment form',
	description:
		'Adds UI to show the amount of additional impressions gained when countries have bonus impressions configured',
	import: false,
});
